<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Indicateurs clés</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/indicateurscle.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <table>
                <tr>
                    <th> Prix au m² à l'achat</th>
                    <td>{{ favorite.price / favorite.square |number:'1.0-1'}} €/m²</td>
                </tr>
                <tr>
                    <th>Prix au m² final</th>
                    <td>{{ favorite.total_price / favorite.square|number:'1.0-1'}} €/m²</td>
                </tr>
                <tr>
                    <th>Rendement brut</th>
                    <td>{{ favorite.efficiency_brut|number:'1.1-1'}} %</td>
                </tr>
                <tr>
                    <th>Rendement net</th>
                    <td>
                        {{ favorite.efficiency_net|number:'1.1-1'}} %
                    </td>
                </tr>
                <tr>
                    <th>Cash-flow annuel</th>
                    <td>
                        {{ favorite.cash_flow * 12|number:'1.0-1'}} €
                    </td>
                </tr>
                <tr>
                    <th>Cash-flow mensuel</th>
                    <td>
                        {{ favorite.cash_flow |number:'1.0-1'}} €
                    </td>
                </tr>
                <tr>
                    <th>Taux de couverture</th>
                    <td>{{ favorite.coverage_rate |number:'1.0-1'}} %</td>
                </tr>
            </table>
        </div>
    </div>
</div>
